import React, { useEffect, useState } from 'react'
import Header from '../Header'
import "./Cart.css"
import { Container } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { removeFromCart, updateFoodQuantityCart } from '../../redux/actions/cartActions'
import { Link } from 'react-router-dom'
import PaymentModal from '../PaymentModal/PaymentModal'
import Footer from '../Footer/footer'

function Cart() {

  let cartList = useSelector(state => state.cartReducer.cart);

  const darkModeState = useSelector(state => state.darkModeReducer.isDarkMode)

  const dispatch = useDispatch();
  console.log("cartList:", cartList)
  const [amount, setAmount] = useState(0)
  const [show, setShow] = useState(false)

  const handleClose = () => setShow(false);

  useEffect(() => {
    let amt = 0;
    cartList.forEach(item => {
      amt = amt + (item.quantity * item.cost)
    })
    setAmount(amt)
  }, [cartList])

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const onUpdateQuantity = (type, id) => {
    let updatedFoodItems = cartList
    updatedFoodItems.forEach(item => {
      if (item.id == id) {
        switch (type) {
          case "ADD":
            item.quantity = item.quantity + 1
            break;
          case "MINUS":
            item.quantity = item.quantity != 1 ? item.quantity - 1 : 1
            break;
        }
      }
    })
    dispatch(updateFoodQuantityCart([...updatedFoodItems]))
  }

  const onClickPlaceOrder = () => {
    setShow(true);
  }

  const onRemoveItem = (id) => {
    let updatedFoodItems = cartList
    updatedFoodItems = updatedFoodItems.filter(item => item.id != id)
    dispatch(removeFromCart([...updatedFoodItems]))
  }

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <PaymentModal show={show} handleClose={handleClose} amount={amount} />

      <Header />

      <Container>
        <div>
          <Container className='cart-container'>
            {cartList.length == 0 &&
              <div className='d-flex flex-column justify-content-center align-items-center mb-5'>
                <img className='cart-no-orders-img' src="/images/cooking 1.png" />
                <h1 className='cart-no-orders'>No Orders Yet</h1>
                <p className='cart-no-orders-desc'>Your cart is empty.<br /> Add something from the menu</p>
                <Link to="/">
                  <button className='btn btn-warning logout-button'>Order Now</button>
                </Link>
              </div>
            }

            {cartList.length > 0 && <div className='cart-context-container'>

              {/* Header */}
              <div className='cart-table-header'>
                <p className='cart-headings equal-width'>Item</p>
                <p className='cart-headings equal-width'>Quantity</p>
                <p className='cart-headings equal-width'>Price</p>
              </div>

              {/* Products */}
              {
                cartList.map(item => {
                  return (
                    <>
                      <div className='cart-item-container-lg'>
                        <div className='equal-width'>
                          <img className="cart-food-item-image" src={item.image_url} />
                        </div>

                        <div className='d-flex align-items-center equal-width'>
                          <button style={{ color:  darkModeState ? '#FFF6EE': '#101720' }} className='btn plus-minus-button' onClick={() => onUpdateQuantity("MINUS", item.id)}>-</button>
                          <span className='ms-2 me-2'>{item.quantity}</span>
                          <button style={{ color:  darkModeState ? '#FFF6EE': '#101720' }} className='btn plus-minus-button me-3' onClick={() => onUpdateQuantity("ADD", item.id)}>+</button>
                          <i class="fa-solid fa-trash-can" onClick={() => onRemoveItem(item.id)}></i>
                        </div>

                        <div className=''>
                          <p className='cart-price'>₹ {item.quantity * item.cost}</p>
                        </div>
                      </div>

                      <div className='cart-item-container-sm'>
                        <div className=''>
                          <img className="cart-food-item-image" src={item.image_url} />
                        </div>

                        <div className='d-flex flex-column justify-content-center mt-2'>
                          <div className='d-flex align-items-center'>
                            <button style={{ color:  darkModeState ? '#FFF6EE': '#101720' }} className='btn plus-minus-button me-2' onClick={() => onUpdateQuantity("MINUS", item.id)}>-</button>
                            <span className='ms-2 me-3'>{item.quantity}</span>
                            <button style={{ color:  darkModeState ? '#FFF6EE': '#101720' }} className='btn plus-minus-button me-3' onClick={() => onUpdateQuantity("ADD", item.id)}>+</button>
                            <i class="fa-solid fa-trash-can" onClick={() => onRemoveItem(item.id)}></i>

                          </div>

                          <div className='mt-2'>
                            <p className='cart-price'>₹ {item.quantity * item.cost}</p>
                          </div>
                        </div>
                      </div>
                    </>
                  )
                })
              }

              {/* Total Amount */}

              <div className='total-amt-container'>
                <hr />
                <h1 className='total-order-title' >Order Total : <span>₹ {amount}</span></h1>
                <div className='d-flex justify-content-center'>
                  <button className='btn btn-warning mt-3 logout-button' onClick={onClickPlaceOrder}>Place Order</button>
                </div>
              </div>

            </div>
            }

          </Container>
        </div>
        <Container>
          <Footer />
        </Container>
      </Container>

      {/* <Container> */}
      {/* </Container> */}
    </>
  )
}

export default Cart